var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"min-width":"100%"}},[_vm._t("meta"),_c('v-col',{style:('height:' + _vm.contentData.Height),attrs:{"cols":"12"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }